<template>
  <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document" style="max-width: 60% !important;">
      <div class="modal-content">
        <div class="modal-header">
            
          <h5 class="modal-title">Product {{ data?.product_id }}</h5>

          
          <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
            aria-label="btn-close"></button>
        </div>

        <div class="modal-body">
          <form ref="formElement">
            <div class="row">


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="master_fr_id" class="col-form-label" style="padding-left: 25px"> Master FR Id </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.master_fr_id" disabled />

                        <div v-if="errors.master_fr_id">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.master_fr_id[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="product_id" class="col-form-label" style="padding-left: 25px"> Product Id </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.product_id" disabled />

                        <div v-if="errors.product_id">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.product_id[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="product_name" class="col-form-label" style="padding-left: 25px"> Product Name </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.product_name" disabled />

                        <div v-if="errors.product_name">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.product_name[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="product_alias" class="col-form-label" style="padding-left: 25px"> Product Alias </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.product_alias" disabled />

                        <div v-if="errors.product_alias">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.product_alias[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="category_in" class="col-form-label" style="padding-left: 25px"> Category IN </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.category_in" disabled />

                        <div v-if="errors.category_in">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.category_in[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="category_dn" class="col-form-label" style="padding-left: 25px"> Category DN </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.category_dn" disabled />

                        <div v-if="errors.category_dn">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.category_dn[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="create_by" class="col-form-label" style="padding-left: 25px"> Create By </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.create_by" disabled />

                        <div v-if="errors.create_by">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.create_by[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="update_by" class="col-form-label" style="padding-left: 25px"> Update By </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.update_by" disabled />

                        <div v-if="errors.update_by">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.update_by[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="created_at" class="col-form-label" style="padding-left: 25px"> Created At </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.created_at" disabled />

                        <div v-if="errors.created_at">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.created_at[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="updated_at" class="col-form-label" style="padding-left: 25px"> Updated At </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <input type="text" class="form-control" :id="$dynamicId()" v-model="forms.updated_at" disabled />

                        <div v-if="errors.updated_at">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.updated_at[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

  
   

 


          
            </div>
          </form>
 



        </div>

        <div class="modal-footer">

          <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')"> Close </button>
          
        </div>

      </div>
    </div>
 

  </div>


</template>

<script> 
export default {
  components: {
    
  },
  name: "ModalPointLoad",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: null,
  },
  watch: {
    showModal: {
      handler(newVal) {
            
        const formElement = this.$refs.formElement;
        if (formElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                const inputs = formElement.querySelectorAll('.multiselect__input');
                inputs.forEach(input => {
                  input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                });
              }
            });
          });

          const inputs = formElement.querySelectorAll('.multiselect__input');
          inputs.forEach(input => {
            observer.observe(input, { attributes: true });
          });
        }

        this.forms = this.data
      
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
        forms: {master_fr_id:"", product_id:"", product_name:"",product_alias:"",category_in:"",category_dn:"", create_by:"", update_by:"" , created_at:"", updated_at:""},
        errors: [],
    };
  },
  methods: {
 
    toFixed(val){
      let data = parseFloat(val).toFixed(2).replace('.', ',');

      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")

    },
 
     
    success2(msg) {
      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },


    errorAlert(msg) {
      this.$swal({
        icon: 'danger',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },


     
    alert(msg) {

      let pesan = '';

      if(msg.length > 0){

        msg.forEach((psn) => {
            pesan = pesan + '<br> id : ' + psn.order_no + ' , status : ' + psn.status
        });

      }

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: "<p>* " + pesan + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },
  
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    error(kata) {
      this.$swal.fire({
        icon: "error",
        title: "Perhatian!",
        text: kata,
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6", // bisa diganti warna sesuai selera
        position: "center",
      });
    },
  
   
 



  },
  mounted() {

    
 
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
/* Important part */
.modal-dialog{
    overflow-y: initial !important
}
.modal-body{
    height: 70vh;
    overflow-y: auto;
}
</style>